import styled from 'styled-components';
const Container = styled.div ``;
const Recaptcha = styled.div ``;
const RecaptchaStyles = {
    Container,
    Recaptcha,
};
export default RecaptchaStyles;
